import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Item/ItemBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingItem"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingItemActivity)
